import React, { Fragment, useEffect, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { useLocation, useNavigate } from 'react-router';
import moment from 'moment';
import AddClinic from './AddClinic';
import EditOrgModal from './EditOrgModal';
import { activeDeactiveClinic, activeDeactiveOrg, getClinicsByOrgIdOrgDetail, getOrgById, updateOrgLogo } from '../../api/orgnizations';
import { decryptData } from '../../utils/helper';
import { orgActions } from '../../context/reducers/organization';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../utils/Tostify';
import Loader from '../../components/Loader/Loader';
import { activateDeactivateStaff, getAssignedStaffs, getUserProfile, removeOrgClinicAccess } from '../../api/User';
import AssignUserModal from './AssignUserModal';
import organization_icon from "../../assets/images/organization-admin.svg";
import Search from "../../components/InputFields/Search";
import { useConfirmDialog } from '../../hooks/useConfirmDialog';
import AssignUser from './AssignUser';
import CustomPagination from '../../components/Pagination/CustomPagination';
import { handleFileUpload } from '../../utils/ImageToBase64';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import noProfileImg from "../../../src/assets/images/noImage.jpg";
import { ITEMS_PER_PAGE } from '../../utils/constants';

function OrganizationViewDetail({ direction, formik, ...args }) {
  let token = useSelector((state) => state.userReducer.token);
  let clinicList = useSelector((state) => state.orgReducer.clinicsData);
  const [activeTab, setActiveTab] = useState('1');
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOrgEditModal, setShowOrgEditModal] = useState(false);
  const [GetUpdatedStaff, setGetUpdatedStaff] = useState([]);
  const [assignedUserList, setAssignedUserList] = useState([]);
  const [showAssignUserModal, setshowAssignUserModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orgData = location?.state?.orgData;
  const orgIdFromState = location.state?.id;
  const addHospital = localStorage.getItem("addHospital");
  const addAssignUser = localStorage.getItem("addAssignUser");
  const [orgDetails, setOrgDetails] = useState(orgData);
  const [isActive, setIsActive] = useState(orgDetails?.active);
  const [search, setSearch] = useState("");
  const [openAddOrg, setOpenAddOrg] = useState(false);
  const [clinicData, setClinicData] = useState({});
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [isChecked, setIsChecked] = useState();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
  const [isEditData, setIsEditData] = useState();
  const userCountClinic = orgData?.clinics?.map(item1 => {
    const match = clinicList?.items?.find(item2 => item2._id === item1._id);
    return match ? { ...match, userCount: item1.userCount } : null;
  }).filter(item => item !== null);

  const { getConfirmation } = useConfirmDialog();
  const [selectedImage, setSelectedImage] = useState(null); // State for selected image file


  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [dropdownfive, setDropdownfive] = useState([]);
  const togglefive = (id) => setDropdownfive(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);

  const getClinicList = async (page = 1, limit = 10, searchKey = "") => {
    let res = "";
    try {
      setIsLoading(true);
      const orgId = orgIdFromState || orgDetails?._id || sessionStorage.getItem("breadCrumpEntityId");
      res = await getClinicsByOrgIdOrgDetail({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        dispatch(orgActions.clinicListing(responseData));
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };
  const handleActiveInActive = async (e, clinicId, type, isActiveUser, clinicName) => {
    if (type === "clinic") {
      if (!orgDetails.active) {
        failed("Organization is not active.");
        return;
      }
    }
    const currentChecked = e.target.checked;
    const confirmed = await getConfirmation({
      title: "Attention!",
      // entryName,
      actionBtnTitle: "Yes",
      message: currentChecked ? `Are you sure you want to enable the ${clinicName}. This will allow previously added users to access this location.` : `Are you sure you want to disable the ${clinicName}. This will restrict access for all the users who were previously added to the location until it is enabled again.`
    });

    if (confirmed) {
      let res;
      try {
        setIsLoading(true);
        if (type === "clinic") {
          res = await activeDeactiveClinic({ dispatch, token, clinicId, isActive: currentChecked });
        } else {
          let staffId = clinicId;
          let isAccess = currentChecked;
          res = await activateDeactivateStaff({ dispatch, token, staffId, isActive: isActiveUser, isAccess });
        }
        if (res?.status === "SUCCESS") {
          await getOrg();
          await getClinicList(clinicList?.currentPage, 10);
          setIsLoading(false);
          setIsChecked(res?.data?.active);
          success(currentChecked ? `The ${clinicName} has been successfully enabled. Users and locations can be added to access the platform.` : `The ${clinicName} has been successfully disabled. Users of this organization can no longer access the platform.`);
        } else {
          setIsLoading(false);
          // Revert the state if the API call fails
          setIsChecked(!currentChecked);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        setIsChecked(!currentChecked);
        failed(res?.message);
      }
    } else {
      setIsChecked(!currentChecked);
    }
  };

  const getOrg = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
      setSearch(searchKey);

      const idToUse = orgData?._id || orgIdFromState;
      if (!idToUse) {
        failed("Organization ID not found.");
        setIsLoading(false);
        return;
      }

      res = await getOrgById({ dispatch, token, orgId: idToUse });
      const responseData = decryptData(res?.data);

      if (res?.status === "SUCCESS") {
        setOrgDetails(responseData);
      } else {
        failed(res?.message || "Failed to fetch organization details.");
      }
    } catch (error) {
      failed(error?.message || "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const confirmed = await getConfirmation({
        title: "Attention!",
        // entryName,
        actionBtnTitle: "Yes",
        message: `Are you sure want to update the logo ?`
      });
      if (confirmed) {
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
        let res;
        try {
          setIsLoading(true);
          const values = {
            orgLogo: e.target.files[0]
          };
          let base64OrgLogo = "";
          if (values?.orgLogo) {
            base64OrgLogo = await handleFileUpload(values?.orgLogo);
          }
          const fileExtension = values?.orgLogo?.type?.split("/")[1];
          const orgLogoURL = {
            base64String: base64OrgLogo,
            extension: fileExtension, // Add the file extension to the object
            name: values?.orgLogo.name
          };
          values.orgLogo = orgLogoURL;
          res = await updateOrgLogo({ values, dispatch, token, orgId: orgData?._id || sessionStorage.getItem("breadCrumpEntityId") });
          if (res?.status == "SUCCESS") {
            await getOrg();
            setIsLoading(false);
            setShowModal(false);
            success(res?.message);
          } else {
            setShowModal(false);
            failed(res.data.message);
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          failed(res?.message);
          setShowModal(false);
        }
      }
    }
  };

  const getAssignedUserList = async (page = 1, limit = 10, searchKey = "") => {
    let res = "";
    try {
      setIsLoading(true);
      const orgId = orgIdFromState || orgData?._id || sessionStorage.getItem("breadCrumpEntityId");
      res = await getAssignedStaffs({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId,
        dataLimit: "all"
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setAssignedUserList(responseData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleActiveInActiveOrg = async (e) => {
    // Store the current checkbox state
    const currentChecked = e.target.checked;
    // Temporarily revert the checkbox state to prevent immediate visual change
    e.target.checked = !currentChecked;
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: currentChecked ? `Are you sure you want to enable the ${orgData?.name}. This will allow all the users who have access to the organization to login in the platform.` : `Are you sure you want to disable the ${orgData?.name}. This will restrict access for all the users who were previously added to the organization until it is enabled again.`
    });
    if (confirmed) {
      let res;
      try {
        setIsLoading(true);
        res = await activeDeactiveOrg({ dispatch, token, orgId: orgData?._id || sessionStorage.getItem("breadCrumpEntityId"), isActive: currentChecked });
        if (res?.status === "SUCCESS") {
          await getClinicList();
          await getOrg();
          setIsActive(currentChecked);
          setIsLoading(false);
          success(currentChecked ? `The ${orgData?.name} has been successfully enabled. Users and locations can be added to access the platform.` : `The ${orgData?.name} has been successfully disabled. Users of this organization can no longer access the platform.`);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        console.log("error", error);
        setIsLoading(false);
        failed(res?.message);
      }
    } else {
      e.target.checked = !currentChecked;
    }
  };
  const handleAddUserClinic = (clinicData) => {
    setShowAssignModal(true);
    setClinicData(clinicData);
  };
  const handlePagination = (page) => {
    getAssignedUserList(page, 10);
  };

  const handleRemoveAccess = async(userId)=>{
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message : `Are you sure want to Remove Access`
        });
        if (confirmed) {
            let values = { isOrgAccess: false, orgId: orgData?._id || sessionStorage.getItem("breadCrumpEntityId"), userId: userId, clinicId: "", updateType: "org"};
            let res;
            try {
                setIsLoading(true);
                res = await removeOrgClinicAccess({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getAssignedUserList(assignedUserList?.currentPage, 10);
                    // res = await getUserProfile({ dispatch, token, values });
                    // const responseData = res?.data;
                    // dispatch(userActions.loginSuccess({...responseData,accessToken: token}));
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(error?.message);
            } finally {
                setIsLoading(false);
            }
        }
  };
  useEffect(() => {
    if (addHospital) {
      setActiveTab("2");
      setShowModal(true);
    } else if (addAssignUser) {
      setActiveTab("3");
      setshowAssignUserModal(true);
    }
  }, [addAssignUser]);

  // useEffect(() => {
  //   getOrg();
  // }, []);

  useEffect(() => {
    getOrg();
  }, [orgData, orgIdFromState]);

  useEffect(() => {
    if (orgIdFromState) {
      getOrg(orgIdFromState);
    }
  }, [orgIdFromState]);

  useEffect(() => {
    getClinicList();
  }, [orgIdFromState]);

  useEffect(() => {
    getAssignedUserList();
  }, [GetUpdatedStaff, orgIdFromState]);

  const handleClick = (event, path) => {
    event.preventDefault();
    navigate(path);
  };


const [currentPage, setCurrentPage] = useState(1);

  const [filteredClinics, setFilteredClinics] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearch(searchValue);

    if (activeTab === "2") {
      setFilteredClinics(
        clinicList?.items?.filter(
          (clinic) =>
            clinic?.name?.toLowerCase().includes(searchValue) ||
            clinic?.address?.[0]?.city?.toLowerCase().includes(searchValue) ||
            clinic?.address?.[0]?.state?.toLowerCase().includes(searchValue)
        )
      );
    } else if (activeTab === "3") {
      setFilteredUsers(
        assignedUserList?.items?.filter(
          (user) =>
            user?.firstName?.toLowerCase().includes(searchValue) ||
            user?.lastName?.toLowerCase().includes(searchValue) ||
            user?.email?.toLowerCase().includes(searchValue) ||
            user?.city?.toLowerCase().includes(searchValue) ||
            user?.state?.toLowerCase().includes(searchValue)
        )
      );
    }
  };

  // Handle sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc"
    }));
  };

  const sortData = (data) => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
      let aValue = a[sortConfig.key] || "";
      let bValue = b[sortConfig.key] || "";

      if (sortConfig.key === "address") {
        aValue = (a?.address?.[0]?.city + ", " + a?.address?.[0]?.state || "").toLowerCase();
        bValue = (b?.address?.[0]?.city + ", " + b?.address?.[0]?.state || "").toLowerCase();
      } else if (sortConfig.key === "location") {
        aValue = (a?.city + ", " + a?.state || "").toLowerCase();
        bValue = (b?.city + ", " + b?.state || "").toLowerCase();
      } else {
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
      }

      return sortConfig.direction === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    });
  };

  useEffect(() => {
    getClinicList();
    getAssignedUserList();
  }, []);

  useEffect(() => {
    setFilteredClinics(sortData(clinicList?.items || []));
    setFilteredUsers(sortData(assignedUserList?.items || []));
  }, [clinicList, assignedUserList, sortConfig]);

  const paginatedClinics = filteredClinics.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const goToUserDetails = (user) => {
    navigate("/super-admin/user-details", { state: user });
  };

  const goToClinicDetails = (clinic, orgData, orgDetails) => {
    navigate("/super-admin/clinicDetail", {
      state: {
        clinicData: { ...clinic, orgName: orgData?.name },
        orgDetails
      }
    });
  };

  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      {showModal && (<AddClinic refetch={() => getClinicList()} setShowModal={() => { setShowModal(!showModal); localStorage.removeItem("addHospital"); }} fromListing={true} />)}
      {showOrgEditModal && <EditOrgModal refetch={() => getOrg()} orgData={orgDetails} setShowModal={() => setShowOrgEditModal(!showOrgEditModal)} />}
      {showAssignUserModal && <AssignUserModal refetch={getAssignedUserList} setGetUpdatedStaff={setGetUpdatedStaff} setshowAssignUserModal={() => { setshowAssignUserModal(!showAssignUserModal); localStorage.removeItem("addAssignUser"); setIsEditData(); }} orgId={orgData?._id || sessionStorage.getItem("breadCrumpEntityId")} alreadyAssignedUserList={assignedUserList?.items?.map((obj) => obj._id)} editData={isEditData} setIsEditData={setIsEditData} />}
      {showAssignModal && (<AssignUser refetch={getAssignedUserList} setShowAssignModal={() => setShowAssignModal(!showAssignModal)} orgData={{ ...orgData, clinicData: clinicData }} refetchClinic={() => getClinicList()} assignedUserList={assignedUserList?.items} from={"clinic"} />)}
      <div className='organization_view_details paginator_blk table_listing_color'>
        <div className="d-flex justify-content-between align-items-center main-header-block header-bg flex-wrap gap-2">
          <div className="left_header d-flex align-items-center">
            <img src={organization_icon} />
            <h2 className="home-title">Organizations</h2>
          </div>
          <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
            <div className="right_header d-flex align-items-center">
              <Search value={search} onChange={handleSearch} />
              <Dropdown direction={direction} isOpen={openAddOrg} toggle={() => setOpenAddOrg((prev)=> !prev)}>
                <DropdownToggle caret size="xl" className="column_blk">
                  <div className="for_details header-add-icon mx-3">
                    <i className="fa fa-plus" ></i>
                  </div>
                </DropdownToggle>
                <DropdownMenu {...args}>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                    <div className="add_hosp" onClick={() => navigate("/super-admin/addOrganization")}>
                      Create Organization
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div>
          <Nav tabs>
            <NavItem>
              <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggle('1')}>
                Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
                Branches ({orgData?.clinics?.length || clinicList?.items?.length || 0})
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>
                Users ({assignedUserList.items?.length || 0})
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">
                  <div className='profile_block'>
                    <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                      <div className='profile_info flex-wrap'>
                        <div className="img_block">
                          <div className="img_profile_container">
                            {selectedImage ? (
                              <img src={selectedImage} alt="Profile" className="img_profile_one" />
                            ) : orgDetails?.orgLogo?.signedUrl ? (
                              <img src={orgDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                            ) : (
                              <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                            )}
                          </div>
													<div className="edit_img">
														<i className='fas fa-pen'></i>
													</div>
													<input
														type="file"
														accept="image/*"
														onChange={handleImageChange}
														className="img_upload_input"
													/>
												</div>
                        <div>
                          <h6>{orgDetails?.name}</h6>
                         <h4>Organization</h4>
                        </div>
                      </div>
                      <button className='edit_profile' onClick={() => setShowOrgEditModal(true)}>Edit Details</button>
                    </div>
                    <div className='data_profile'>
                      <div className='row'>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Organization</h4>
                          <p>{orgDetails?.name}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Organization Type</h4>
                          <p>{orgDetails?.type}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Primary Contact</h4>
                          <p>{orgDetails?.contact?.[0]?.name} | {orgDetails?.contact?.[0]?.telecom.find((val) => val.system == "email")?.value}
                            <br />
                            {orgDetails?.contact?.[0]?.telecom.find((val) => val.system == "phone")?.value}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Secondary Contact</h4>
                          <p>{(orgDetails?.contact?.[1]?.name && orgDetails?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value) ? orgDetails?.contact?.[1]?.name | orgDetails?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value : "NA"}
                            <br />
                            {orgDetails?.contact?.[1]?.telecom.find((val) => val.system == "phone")?.value}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Address</h4>
                          <p>{orgDetails?.address?.[0]?.city + "," + orgDetails?.address?.[0]?.state},
                            <br />{orgDetails?.address?.[0]?.country} - {orgDetails?.address?.[0]?.postalCode}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Phone</h4>
                          <p>{orgDetails?.telecom?.find((val) => val.system == "phone")?.value ? "+" + orgDetails?.telecom?.find((val) => val.system == "phone")?.value : "NA"}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Total Users</h4>
                          <p>{assignedUserList?.items?.length}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Create Date</h4>
                          <p>{moment(orgDetails?.createdAt).format("MMM-DD-YYYY")}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4>Update Date</h4>
                          <p>{moment(orgDetails?.updatedAt).format("MMM-DD-YYYY")}</p>
                        </div>
                        <div className='col-lg-3 col-sm-6 mb-4'>
                         <h4 className='mb-2'>Active Status</h4>
                          <p> <div className="toggle">
                            <input type="checkbox" id="checktoggle" checked={orgDetails?.active} onChange={(e) => handleActiveInActiveOrg(e)} />
                            <label htmlFor="checktoggle"></label>
                          </div></p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3 justify-content-center mt-3">
                      <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <div className='profile_block'>
                <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                  <div className='profile_info'>
                      <div className="img_block">
                        <div className="img_profile_container">
                          {selectedImage ? (
                            <img src={selectedImage} alt="Profile" className="img_profile_one" />
                          ) : orgDetails?.orgLogo?.signedUrl ? (
                            <img src={orgDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                          ) : (
                            <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                          )}
                        </div>
                        <div className="edit_img">
                          <i className='fas fa-pen'></i>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          className="img_upload_input"
                        />
                      </div>
                    <div>
                      <h6>{orgDetails?.name}</h6>
                     <h4>Organization</h4>
                    </div>
                  </div>
                  <button className='edit_profile' onClick={() => setShowOrgEditModal(true)}>Edit Details</button>
                </div>
                <div className="table_space">
                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr className="header_table">
                          <th onClick={() => handleSort("name")}>Name<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("createdAt")}>Create Date<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("address")}>Location<i className='fas fa-sort'></i></th>
                          <th>Status</th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      {sortData(paginatedClinics)?.map((clinic, index) => (
                        <tbody key={clinic?._id}>
                          <tr><td colSpan={9} height={5} className="bg_light"></td></tr>
                          <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                          <td
                            onClick={() => goToClinicDetails(clinic, orgData, orgDetails)}
                            style={{ cursor: "pointer", color: "blue"}}
                            className="title_name"
                          >
                            {clinic?.name}
                          </td>
                            <td>{moment(clinic?.createdAt).format("MMM-DD-YYYY")}</td>
                            <td>{clinic?.address?.[0]?.city + "," + clinic?.address?.[0]?.state}</td>
                            <td>
                              <label className="switch">
                                <input type="checkbox" defaultChecked={() => setIsChecked(clinic?.active)} onChange={(e) => handleActiveInActive(e, clinic?._id, "clinic", "", clinic?.name)} checked={clinic?.active} />
                                <span className="slider round"></span>
                              </label>
                            </td>
                            <td><div className='user_table_blk'><i className="fa fa-user"></i>{clinic?.userCount || 0}</div></td>
                            <td>
                              <Dropdown isOpen={dropdownfive.includes(clinic?._id)} toggle={() => togglefive(clinic?._id)} direction={direction}>
                                <DropdownToggle caret size="xl" className="drop_blk">
                                  <div className="for_details">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </div>
                                </DropdownToggle>
                                <DropdownMenu {...args}>
                                  {clinic?.active ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleAddUserClinic(clinic)}>
                                    <button className="add_hosp">Add User</button>
                                  </DropdownItem> : null}
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => navigate("/super-admin/clinicDetail", { state: { clinicData: {...clinic, orgName : orgData?.name},orgDetails} })}>
                                    <button className="add_hosp">View Details</button>
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                    <div>
                      <CustomPagination
                        tableData={filteredClinics}  // Pass full data
                        totalPages={Math.ceil(filteredClinics.length / ITEMS_PER_PAGE)}
                        totalRows={filteredClinics.length}
                        rowsPerPage={ITEMS_PER_PAGE}
                        page={currentPage}
                        handlePage={(page) => setCurrentPage(page)}  // Update page state
                      />
                    </div>
                  </div>
              </div>
              <div className='d-flex justify-content-center mt-3 gap-3'>
                <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
                <button className='acess_btn d-flex align-items-center gap-2' disabled={orgDetails?.active === false} onClick={() => setShowModal(true)}><i className="fa fa-plus"></i>Add Location</button>
              </div>
            </TabPane>
            <TabPane tabId="3" className='tab_three'>
              <div className='profile_block'>
                <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                  <div className='profile_info'>
                    <div className="img_block">
                       <div className="img_profile_container">
                          {selectedImage ? (
                            <img src={selectedImage} alt="Profile" className="img_profile_one" />
                          ) : orgDetails?.orgLogo?.signedUrl ? (
                            <img src={orgDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                          ) : (
                            <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                          )}
                        </div>
                      <div className="edit_img">
                        <i className='fas fa-pen'></i>
                      </div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="img_upload_input"
                      />
                    </div>
                    <div>
                      <h6>{orgDetails?.name}</h6>
                     <h4>Organization</h4>
                    </div>
                  </div>
                  <button className='edit_profile' onClick={() => setShowOrgEditModal(true)}>Edit Details</button>
                </div>
                <div className="table_space">
                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr className="header_table">
                          <th onClick={() => handleSort("firstName")}>Full Name <i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("email")}>Email<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("employer")}> Employer<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("location")}>Location<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("createdAt")}>Joined<i className='fas fa-sort'></i></th>
                          <th>Active</th>
                          <th></th>
                        </tr>
                      </thead>
                      {sortData(paginatedUsers)?.map((user, index) => (
                        <tbody key={user?._id}>
                          <tr><td colSpan={9} height={5} className="bg_light"></td></tr>
                          <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                            {/* <td>{user?.firstName + " " + user?.lastName}</td> */}
                            <td onClick={() => goToUserDetails(user)} style={{ cursor: "pointer", color: "blue" }}>
                              {user?.firstName + " " + user?.lastName}
                            </td>
                            <td>{user?.email}</td>
                            <td>{user?.employer}</td>
                            <td>{user?.city + "," + user?.state}</td>
                            <td>{moment(user?.createdAt).format("MMM-DD-YYYY")}</td>
                            <td><div className={user?.active === true ? "active_block_btn" : "not_active_btn"}>{user?.active == true ? "Active" : "Not Active"}</div></td>
                            <td>
                              <Dropdown isOpen={dropdownfive.includes(user?._id)} toggle={() => togglefive(user?._id)} direction={direction}>
                                <DropdownToggle caret size="xl" className="drop_blk">
                                  <div className="for_details">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </div>
                                </DropdownToggle>
                                <DropdownMenu {...args}>
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                    <button
                                      className="add_hosp"
                                      onClick={(e) => handleRemoveAccess(user?._id)}
                                    >
                                      Remove Access
                                    </button>
                                  </DropdownItem>
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => {setshowAssignUserModal(true);setIsEditData(user);}}>
                                    <button className="add_hosp">Edit User Access</button>
                                  </DropdownItem>
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => navigate("/super-admin/user-details", { state: user })}>
                                    <button className="add_hosp">View Details</button>
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={9} height={5} className="bg_light"></td>
                          </tr>
                        </tbody>))}
                    </table>
                  </div>
                    <CustomPagination
                      tableData={filteredUsers}  // Pass full data
                      totalPages={Math.ceil(filteredUsers.length / ITEMS_PER_PAGE)}
                      totalRows={filteredUsers.length}
                      rowsPerPage={ITEMS_PER_PAGE}
                      page={currentPage}
                      handlePage={(page) => setCurrentPage(page)}  // Update page state
                    />
                  </div>
              </div>
              <div className='d-flex justify-content-center gap-3 mt-3'>
                <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
                <button className='acess_btn d-flex align-items-center gap-2' disabled={orgDetails?.active === false} onClick={() => setshowAssignUserModal(true)}><i className="fa fa-plus"></i>Add User Access</button>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Fragment>
  );
}

export default OrganizationViewDetail;
